import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as fundsActions from "../../../redux/actions/FundsActions";

import FundModal from "../fundsCommon/FundModal";
import FundDetailsCard from "./FundDetailsCard";
import ReconciliationReports from "./ReconciliationReports";
import AllTransactionsTable from "./AllTransactionsTable";
import OutsideTransactionsTable from "./OutsideTransactionsTable";
import ReportModal from "./ReportModal";
import OutsideTransactionModal from "../fundsCommon/OutsideTransactionModal";
import BankReconciliationModal from "./NewBankReconciliation/BankReconciliationModal";
import DateRangePicker from "./DateRangePicker";
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import Select from "../../commonComponents/util/Select";
import ConfirmationModal from "../../commonComponents/shared/ConfirmationModal";
import TransactionNoteModal from "./TransactionNoteModal";

import { formatDate } from "../../../lib/utils";
import { getRequest } from "../../../lib/apiUtils";
import { Departments, PermissionTypes } from "../../../lib/systemVariables";

import { toastr } from "react-redux-toastr";
import { debounce } from "throttle-debounce";

const views = {
  AllTransactions: "allTrans",
  OutsideTransactions: "outsideTrans",
  BankReconciliation: "bankRecon"
};

class FundDetailsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      view: views.AllTransactions,
      fundId: this.props.match.params.id,
      showModals: {
        fundModal: false,
        reportModal: false,
        outsideTransactionModal: false,
        newBankReconiliationModal: false,
        transactionNoteModal: false,
        confirmRevertReconciliationStatusModal: false
      },
      selectedTrans: [],
      selectedReport: null,
      selectedTransForUpdate: null
    };

    this.getFundDetails = this.getFundDetails.bind(this);
    this.getTransactionsForExport = this.getTransactionsForExport.bind(this);
    this.searchTransactions = debounce(500, this.searchTransactions).bind(this);
  }

  componentWillMount() {
    if (this.state.fundId) {
      this.getFundDetails();
    }
  }

  componentWillUnmount() {
    this.props.actions.clearFundDetails();
  }

  async getFundDetails() {
    await this.props.actions.getFundDetails(this.state.fundId);
    if (!this.props.fundDetails.success)
      toastr.error(
        "Something went wrong",
        `We were unable to retrieve fund information.  Please try again.`
      );
  }

  toggleTable(view) {
    if (this.state.view !== view) this.setState({ view: view });
  }

  updateTransFilters(name, value, transTable, getTransactions) {
    const params = [
      this.state.fundId,
      { [name]: value },
      getTransactions,
      this.props[transTable].sort,
      this.props[transTable].results
    ];
    transTable === "transactionsTable"
      ? this.props.actions.updateTransactionsFilters(...params)
      : this.props.actions.updateOutsideTransactionsFilters(...params);

    if (name === "search") this.searchTransactions(transTable);
  }

  searchTransactions(transTable) {
    const params = [
      this.state.fundId,
      1,
      this.props[transTable].results,
      this.props[transTable].sort
    ];
    transTable === "transactionsTable"
      ? this.props.actions.getTransactions(...params)
      : this.props.actions.getOutsideTransactions(...params);
  }

  searchTransactionsAllTime(transTable) {
    const params = [
        this.state.fundId,
        {
            startDate: "",
            endDate: ""
        },
        true,
        this.props[transTable].sort,
        this.props[transTable].results
      ];
      transTable === "transactionsTable"
        ? this.props.actions.updateTransactionsFilters(...params)
        : this.props.actions.updateOutsideTransactionsFilters(...params);
  }

  selectTransaction(checked, transactionId) {
    if (checked) {
      this.setState({
        selectedTrans: [...this.state.selectedTrans, transactionId]
      });
    } else {
      this.setState({
        selectedTrans: this.state.selectedTrans.filter(t => t !== transactionId)
      });
    }
  }

  async voidTransactions() {
    await this.props.actions.voidTransactions(
      this.state.fundId,
      this.state.selectedTrans
    );
    if (this.props.voidTransactions.success)
      this.setState({ selectedTrans: [] });
  }

  renderActions() {
    switch (this.state.view) {
      case views.AllTransactions:
        return (
          <div className="flex-center transaction-filters">
            <div className="search-input-container">
              <div className="search-input">
                <i className="material-icons">search</i>
                <input
                  type="text"
                  name="search"
                  placeholder="Search Transactions"
                  value={this.props.transactionsFilters.search}
                  onChange={e =>
                    this.updateTransFilters(
                      e.target.name,
                      e.target.value,
                      "transactionsTable",
                      false
                    )
                  }
                />
              </div>
            </div>
            <DateRangePicker
              startDate={this.props.transactionsFilters.startDate}
              endDate={this.props.transactionsFilters.endDate}
              update={(name, val) =>
                this.updateTransFilters(name, val, "transactionsTable", true)
              }
            />
            <button
                className="btn btn-primary"
                onClick={() => this.searchTransactionsAllTime("transactionsTable")}
            >
                All Time
            </button>
            {this.props.userPermissions.report && (
              <button
                className="btn btn-primary"
                onClick={this.toggleModal.bind(this, "reportModal")}
                disabled={
                  !(
                    this.props.transactionsTable.data.records &&
                    this.props.transactionsTable.data.records.length
                  )}
              >
                New Report
              </button>
            )}
          </div>
        );
      case views.OutsideTransactions:
        return (
          <div className="flex-center transaction-filters">
            <div className="search-input-container">
              <div className="search-input">
                <i className="material-icons">search</i>
                <input
                  type="text"
                  name="search"
                  placeholder="Search Transactions"
                  value={this.props.outsideTransactionsFilters.search}
                  onChange={e =>
                    this.updateTransFilters(
                      e.target.name,
                      e.target.value,
                      "outsideTransactionsTable",
                      false
                    )
                  }
                />
              </div>
            </div>
            <DateRangePicker
              startDate={this.props.outsideTransactionsFilters.startDate}
              endDate={this.props.outsideTransactionsFilters.endDate}
              update={(name, val) =>
                this.updateTransFilters(
                  name,
                  val,
                  "outsideTransactionsTable",
                  true
                )
              }
            />
            <button
                className="btn btn-primary"
                onClick={() => this.searchTransactionsAllTime("outsideTransactionsTable")}
            >
                All Time
            </button>
            {this.props.userPermissions.manageAccounting && (
              <button
                className="btn btn-primary"
                onClick={this.toggleModal.bind(
                  this,
                  "outsideTransactionModal"
                )}
              >
                Add
              </button>
            )}
            {this.state.selectedTrans.length > 0 && (
              <div className="flex-center void">
                <p>
                  {this.state.selectedTrans.length} item
                  {this.state.selectedTrans.length > 1 && "s"} selected
                </p>
                <button
                  className="btn btn-flat btn-small"
                  disabled={this.props.voidTransactions.loading}
                  onClick={this.toggleModal.bind(this, "confirmVoidModal")}
                >
                  Void Selected
                </button>
              </div>
            )}
            {this.props.userPermissions.report && (
              <button
                className="btn btn-primary"
                disabled={
                  !(
                    this.props.outsideTransactionsTable.data.records &&
                    this.props.outsideTransactionsTable.data.records.length
                  )
                }
                onClick={this.toggleModal.bind(this, "reportModal")}
              >
                New Report
              </button>
            )}
          </div>
        );
      case views.BankReconciliation:
        return (
          <div className="flex-center flex-justify transaction-filters">
            {this.props.reconciliationReports.reconciliationReports.data
              .lastReconciliation && (
              <p className="small-text accent-text icon-left">{`Last Reconciliation: ${formatDate(
                this.props.reconciliationReports.reconciliationReports.data
                  .lastReconciliation
              )}`}</p>
            )}
            {this.props.reconciliationReports.reconciliationReports.data
              .years &&
              this.props.reconciliationReports.reconciliationReports.data.years
                .length > 0 && (
                <Select
                  placeholder="Year"
                  options={this.props.reconciliationReports.reconciliationReports.data.years.map(
                    year => ({
                      key: year,
                      value: year
                    })
                  )}
                  value={this.props.reconciliationReports.filters.year}
                  name="year"
                  onChange={e =>
                    this.props.actions.updateReconciliationReportsFilters(
                      { year: e.target.value },
                      this.state.fundId
                    )
                  }
                />
              )}
            {this.props.userPermissions.manageAccounting &&
              !this.props.reconciliationReports.reconciliationReports
                .loading && (
                <button
                  className="btn btn-primary btn-small"
                  onClick={this.toggleModal.bind(
                    this,
                    "newBankReconiliationModal"
                  )}
                >
                  {this.props.reconciliationReports.reconciliationReports.data.reconciliationInProgressReportId
                    ? "Continue Reconciliation"
                    : "Reconcile Now"}
                </button>
              )}
          </div>
        );
      default:
        return <div />;
    }
  }

  async getTransactionsForExport(params) {
    if (this.state.view === views.BankReconciliation) {
      return await getRequest(
        `/funds/${this.state.fundId}/reconciliationReports/${
          this.state.selectedReport.id
        }`,
        params
      );
    } else {
      return await getRequest(
        `/funds/${this.state.fundId}/transactions/report`,
        params
      );
    }
  }

  reloadTransactionsTable = () => {
    const isOutsideTrans = this.state.view === views.OutsideTransactions;
    if(isOutsideTrans) {
      this.props.actions.getOutsideTransactions(
        this.state.fundId,
        this.props.outsideTransactionsTable.page,
        this.props.outsideTransactionsTable.resultsView,
        this.props.outsideTransactionsTable.sort
      );
    } else {
      this.props.actions.getTransactions(
        this.state.fundId,
        this.props.transactionsTable.page,
        this.props.transactionsTable.resultsView,
        this.props.transactionsTable.sort
      );
    }
  }

  render() {
    const { fundDetails, userPermissions } = this.props;
    const fund = fundDetails.data;
    return (
      <div className="page">
        <div className="subheader funds-subheader fund-details-subheader">
          <div className="container">
            {fundDetails.loading ? (
              <LoadingSpinner height={20} />
            ) : (
              <FundDetailsCard
                fund={fund}
                isIsraeli={fund.department === Departments.IL}
                toggleModal={this.toggleModal.bind(this, "fundModal")}
                permissions={userPermissions}
              />
            )}
          </div>
        </div>
        <div className="transactions-tabs">
          <div className="container flex-justify flex-center">
            <ul className="transaction-options flex">
              <li>
                <a
                  className={`${
                    this.state.view === views.AllTransactions ? "active" : ""
                  } accent-text medium-text`}
                  onClick={this.toggleTable.bind(this, views.AllTransactions)}
                >
                  All Transactions
                </a>
              </li>
              <li>
                <a
                  className={`${
                    this.state.view === views.OutsideTransactions
                      ? "active"
                      : ""
                  } accent-text medium-text`}
                  onClick={this.toggleTable.bind(
                    this,
                    views.OutsideTransactions
                  )}
                >
                  Outside Transactions
                </a>
              </li>
              <li>
                <a
                  className={`${
                    this.state.view === views.BankReconciliation ? "active" : ""
                  } accent-text medium-text`}
                  onClick={this.toggleTable.bind(
                    this,
                    views.BankReconciliation
                  )}
                >
                  Bank Reconciliation
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="container transactions-page">
          {this.renderActions()}
          {this.state.view === views.AllTransactions && (
            <AllTransactionsTable
              isIsraeli={fund.department === Departments.IL}
              {...this.props.transactionsTable}
              updateTable={this.props.actions.updateTransactionsTable}
              getTransactions={this.props.actions.getTransactions.bind(
                this,
                this.state.fundId
              )}
              canUpdate={this.props.userPermissions.manageAccounting}
              onClickReconciliationNote={(trans) => {
                this.setState({
                  selectedTransForUpdate: trans
                }, this.toggleModal.bind(this, "transactionNoteModal"));
              }}
              onUpdateReconciliationStatus={(trans) => {
                this.setState({
                  selectedTransForUpdate: trans
                }, this.toggleModal.bind(this, "confirmRevertReconciliationStatusModal"));
              }}
            />
          )}
          {this.state.view === views.OutsideTransactions && (
            <OutsideTransactionsTable
              selectedTrans={this.state.selectedTrans}
              isIsraeli={fund.department === Departments.IL}
              {...this.props.outsideTransactionsTable}
              updateTable={this.props.actions.updateOutsideTransactionsTable}
              getTransactions={this.props.actions.getOutsideTransactions.bind(
                this,
                this.state.fundId
              )}
              selectTransaction={this.selectTransaction.bind(this)}
              canUpdate={this.props.userPermissions.manageAccounting}
              onUpdateTransaction={(trans) => {
                this.setState({
                  selectedTransForUpdate: trans
                }, this.toggleModal.bind(this, "outsideTransactionModal"));
              }}
              onClickReconciliationNote={(trans) => {
                this.setState({
                  selectedTransForUpdate: trans
                }, this.toggleModal.bind(this, "transactionNoteModal"));
              }}
              onUpdateReconciliationStatus={(trans) => {
                this.setState({
                  selectedTransForUpdate: trans
                }, this.toggleModal.bind(this, "confirmRevertReconciliationStatusModal"));
              }}
              userId={this.props.userId}
            />
          )}
          {this.state.view === views.BankReconciliation && (
            <ReconciliationReports
              permissions={userPermissions}
              {...this.props.reconciliationReports}
              fundId={this.state.fundId}
              deleteReport={this.props.actions.deleteReconciliationReport}
              getReports={this.props.actions.getReconciliationReports}
              downloadReport={(reportId, reportName) => {
                this.setState(
                  {
                    selectedReport: {
                      id: reportId,
                      name: reportName
                    }
                  },
                  this.toggleModal.bind(this, "reportModal")
                );
              }}
            />
          )}
        </div>

        <ReportModal
          allowGroupedResults={this.state.view === views.AllTransactions}
          close={() => {
            this.toggleModal("reportModal");
            if (this.state.selectedReport) {
              this.setState({ selectedReport: null });
            }
          }}
          fundName={fund.name}
          getTransactionsForExport={this.getTransactionsForExport}
          reportName={
            this.state.view === views.BankReconciliation &&
            this.state.selectedReport
              ? this.state.selectedReport.name
              : null
          }
          reportType={
            this.state.view === views.OutsideTransactions
              ? "OutsideTransactionsReport"
              : this.state.view === views.BankReconciliation
              ? "BankReconciliationReport"
              : null
          }
          show={this.state.showModals.reportModal}
          tableSettings={this.state.view === views.OutsideTransactions ? this.props.outsideTransactionsTable : this.props.transactionsTable}
          filterSettings={this.state.view === views.OutsideTransactions ? this.props.outsideTransactionsFilters : this.props.transactionsFilters}
        />

        <OutsideTransactionModal
          isIsraeli={fund.department === Departments.IL}
          fundId={this.state.fundId}
          onSuccess={this.props.actions.getOutsideTransactions.bind(
            this,
            this.state.fundId,
            1,
            this.props.outsideTransactionsTable.resultsView,
            this.props.outsideTransactionsTable.sort
          )}
          onUpdateTransactionType={() => {
            if (
              this.props.outsideTransactionsTable.data.records &&
              this.props.outsideTransactionsTable.data.records.length
            ) {
              this.props.actions.getOutsideTransactions(
                this.state.fundId,
                this.props.outsideTransactionsTable.page,
                this.props.outsideTransactionsTable.resultsView,
                this.props.outsideTransactionsTable.sort
              );
            }
          }}
          show={this.state.showModals.outsideTransactionModal}
          close={() => {
            this.setState({
              selectedTransForUpdate: null
            }, this.toggleModal.bind(this, "outsideTransactionModal"));
          }}
          transactionForUpdate={this.state.selectedTransForUpdate}
        />

        <BankReconciliationModal
          {...this.props.reconciliationReports}
          fund={this.props.fundDetails.data}
          getReconciliationReport={this.props.actions.getReconciliationReport}
          createReconciliationReport={
            this.props.actions.createReconciliationReport
          }
          createAndCompleteReconciliationReport={
            this.props.actions.createAndCompleteReconciliationReport
          }
          updateReconciliationReport={
            this.props.actions.updateReconciliationReport
          }
          completeReconciliationReport={
            this.props.actions.completeReconciliationReport
          }
          clearReconciliationDetails={
            this.props.actions.clearReconciliationDetails
          }
          //payments table:
          selectPayment={this.props.actions.toggleSelectReconciliationPayments}
          selectCredit={this.props.actions.toggleSelectReconciliationCredits}
          reconciliationPayments={this.props.reconciliationPaymentsTable}
          getPayments={this.props.actions.getReconciliationPayments.bind(
            this,
            this.state.fundId
          )}
          //credits table:
          reconciliationCredits={this.props.reconciliationCreditsTable}
          getCredits={this.props.actions.getReconciliationCredits.bind(
            this,
            this.state.fundId
          )}
          selectCredit={this.props.actions.toggleSelectReconciliationCredits}

          updateAdjustments={this.props.actions.updateReconciliationAdjustments}
          show={this.state.showModals.newBankReconiliationModal}
          close={() => {
            this.toggleModal("newBankReconiliationModal");
            this.props.actions.clearReconciliationDetails();
          }}
        />

        <FundModal
          show={this.state.showModals.fundModal}
          fund={fund}
          utils={this.props.utils}
          userPermissions = {this.props.userPermissions}
          close={this.toggleModal.bind(null, "fundModal")}
          {...this.props.updateFund}
          createFund={this.props.actions.updateFundDetails.bind(
            this,
            fund.fundId
          )}
          reloadFunds={this.props.actions.getFundDetails.bind(
            this,
            fund.fundId
          )}
        />

        <ConfirmationModal
          show={this.state.showModals.confirmVoidModal}
          close={() => {
            this.toggleModal("confirmVoidModal");
          }}
          message="Are you sure you want to void these transactions?"
          confirm={this.voidTransactions.bind(this)}
          loading={this.props.voidTransactions.loading}
          success={this.props.voidTransactions.success}
        />

      <ConfirmationModal
          close={() => {
            this.toggleModal("confirmRevertReconciliationStatusModal");
            this.setState({ selectedTransForUpdate: null });
          }}
          confirm={async () => {
            await this.props.actions.updateTransactionDetails(
              this.state.fundId, 
              this.state.selectedTransForUpdate.transactionId, 
              { 
                reconciliationId: null,
                reconciliationNote: null
              }
            );
            
            if(this.props.updateTransaction.success) {
              this.reloadTransactionsTable();
            }
          }}
          loading={this.props.updateTransaction.loading}
          message="Are you sure want to change the reconciliation status of this transaction to uncleared?"
          show={this.state.showModals.confirmRevertReconciliationStatusModal}
          success={this.props.updateTransaction.success}
        />

      <TransactionNoteModal
          close={() => {
            this.toggleModal("transactionNoteModal");
            this.setState({ selectedTransForUpdate: null });
          }}
          loading={this.props.updateTransaction.loading}
          saveAsync={async (text) => {
              await this.props.actions.updateTransactionDetails(
                this.state.fundId, 
                this.state.selectedTransForUpdate.transactionId, 
                { reconciliationNote: text }
              );

              if(this.props.updateTransaction.success) {
                this.reloadTransactionsTable();
              }
          }}
          show={this.state.showModals.transactionNoteModal}
          success={this.props.updateTransaction.success}
          text={this.state.selectedTransForUpdate ? this.state.selectedTransForUpdate.reconciliationNote : ""}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.fundDetails,
    transactionsTable: state.accountingTransactionsTable,
    outsideTransactionsTable: state.accountingOutsideTransactionsTable,
    reconciliationPaymentsTable: state.reconciliationPaymentsTable,
    reconciliationCreditsTable: state.reconciliationCreditsTable,
    reconciliationReports: state.reconciliationReports,
    utils: {
      banks: state.settings.systemSettings.data.fundSettings.banks,
      departments: state.settings.systemSettings.data.otherSettings.departments,
      unitTypes: state.settings.systemSettings.data.otherSettings.unitTypes
    },
    userId: state.userProfile.profile.data.userId,
    userPermissions: {
      manageAccounting: state.userProfile.permissions.data.indexOf(PermissionTypes.AccountingManage) >= 0,
      report: state.userProfile.permissions.data.indexOf(PermissionTypes.Reporting) >= 0,
      admin: state.userProfile.profile.data.roleId === 1
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(fundsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundDetailsPage);



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/FundDetailsPage.jsx